import React, { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Megaphone, Phone } from "lucide-react";

const ST = {
  novo: { l: "Novo", c: "bg-aj-amber-soft text-aj-orange-hover" },
  contatado: { l: "Contatado", c: "bg-[#DBEAFE] text-[#142766]" },
  convertido: { l: "Convertido", c: "bg-aj-success text-white" },
  descartado: { l: "Descartado", c: "bg-[#F4F4F5] text-aj-text-muted" },
};
const FLUXO = ["novo", "contatado", "convertido", "descartado"];

export default function LeadsDemonstracao() {
  const [docs, setDocs] = useState(null);
  const [filtro, setFiltro] = useState("todos");

  const load = useCallback(() => {
    api.get("/admin/leads-demonstracao").then(r => setDocs(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);
  useEffect(load, [load]);

  const mudarStatus = async (lead, status) => {
    try {
      await api.put(`/admin/leads-demonstracao/${lead.id}/status`, { status });
      toast.success(`Lead marcado como ${ST[status].l.toLowerCase()}`);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const visiveis = (docs || []).filter(d => filtro === "todos" || (d.status || "novo") === filtro);

  return (
    <div className="space-y-6" data-testid="leads-page">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-aj-orange">Comercial</div>
        <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-aj-blue-deep mt-1">Leads de Demonstração</h1>
        <p className="text-sm text-aj-text-muted mt-1">Pedidos de demonstração enviados pela landing. Atualize o status conforme o contato avança.</p>
      </div>

      <div className="flex gap-2 flex-wrap">
        {["todos", ...FLUXO].map(f => (
          <button key={f} onClick={() => setFiltro(f)}
            className={`px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wide border transition
              ${filtro === f ? "bg-aj-blue-deep text-white border-aj-blue-deep" : "bg-white text-aj-text-muted border-[#E2E8F0] hover:border-aj-blue-deep"}`}
            data-testid={`leads-filtro-${f}`}>
            {f === "todos" ? "Todos" : ST[f].l}
          </button>
        ))}
      </div>

      <div className="space-y-3">
        {docs === null && <div className="aj-card p-10 text-center text-aj-text-muted">Carregando…</div>}
        {docs !== null && visiveis.length === 0 && (
          <div className="aj-card p-10 text-center text-aj-text-muted" data-testid="leads-vazio">
            <Megaphone className="w-8 h-8 mx-auto mb-2 opacity-40" />
            Nenhum lead {filtro !== "todos" ? `com status "${ST[filtro]?.l}"` : "recebido ainda"}.
          </div>
        )}
        {visiveis.map(d => {
          const st = ST[d.status || "novo"];
          return (
            <div key={d.id} className="aj-card p-5" data-testid={`lead-card-${d.id}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-display font-bold text-aj-blue-deep">{d.nome}</span>
                    {d.empresa && <span className="text-sm text-aj-text-muted">· {d.empresa}</span>}
                    <span className={`px-2 py-0.5 rounded-md text-[10px] font-bold uppercase ${st.c}`}
                      data-testid={`lead-status-${d.id}`}>{st.l}</span>
                  </div>
                  <div className="text-xs text-aj-text-muted mt-1.5 flex items-center gap-3 flex-wrap">
                    <a href={`https://wa.me/55${(d.whatsapp || "").replace(/\D/g, "")}`} target="_blank" rel="noreferrer"
                      className="inline-flex items-center gap-1 font-semibold text-aj-success hover:underline"
                      data-testid={`lead-whats-${d.id}`}>
                      <Phone size={12} /> {d.whatsapp}
                    </a>
                    <span>{new Date(d.criado_em).toLocaleString("pt-BR")}</span>
                  </div>
                </div>
                <div className="flex gap-2 flex-wrap">
                  {FLUXO.filter(s => s !== (d.status || "novo")).map(s => (
                    <Button key={s} size="sm" variant="outline" onClick={() => mudarStatus(d, s)}
                      data-testid={`lead-marcar-${s}-${d.id}`}>
                      {ST[s].l}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
